"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var next_components_1 = require("@dotdev/next-components");
var Snippets = require("snippets");
var AfterPay = /** @class */ (function (_super) {
    __extends(AfterPay, _super);
    function AfterPay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AfterPay.prototype.render = function () {
        var _a = this.props, cart = _a.cart, className = _a.className, format = _a.format, price = _a.price;
        return price ? (React.createElement("div", { className: className }, cart ? (React.createElement(React.Fragment, null,
            React.createElement("p", { className: "block whitespace-no-wrap" },
                "Or 4 fortnightly payments of ",
                next_components_1.ShopifyNext.Utils.formatMoney(price / 4, format),
                " with"),
            React.createElement("a", { href: "//afterpay.com/terms", target: "_blank", className: "block ml-0-5", title: "Afterpay Terms & Conditions", "aria-label": "Afterpay Terms & Conditions", role: "link", rel: "noreferrer" },
                React.createElement(Snippets.Svg, { name: "payment-afterpay-colour", height: 12, className: "block" })))) : (React.createElement(React.Fragment, null,
            React.createElement("p", { className: "block" },
                "or 4 payments of",
                next_components_1.ShopifyNext.Utils.formatMoney(price / 4, format),
                " with"),
            React.createElement("a", { href: "//afterpay.com/terms", target: "_blank", className: "block text-midnight hover:text-charcoal transition-fast", title: "Afterpay Terms & Conditions", "aria-label": "Afterpay Terms & Conditions", role: "link", rel: "noreferrer" },
                React.createElement(Snippets.Svg, { name: "payment-afterpay-colour", height: 12, className: "inline-block align-middle mx-0-5" })))))) : null;
    };
    return AfterPay;
}(React.PureComponent));
exports.AfterPay = AfterPay;
